var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full min-w-full h-screen flex overflow-hidden bg-cool-gray-100"},[_c('Sidebar',{staticClass:"w-2/12"}),_c('div',{staticClass:"w-10/12"},[_c('Header'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }